






































import pdf from 'vue-pdf'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import GetExternalLinkFileApi from '@/app/model/api/getExternalLinkFileApi'
import ExternalLinkContentDetailApi from '@/app/model/api/externalLinkContentDetailApi'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    pdf
  }
})

export default class PdfPreview extends Vue {
  @Prop() private title!: string
  @Prop() private path!: string
  private numPages: number = 0

  @Watch('path')
  getPath () {
    this.getFilePage()
  }

  private async getFilePage () {
    const pdfData: any = await pdf.createLoadingTask(this.path)
    pdfData.promise.then((data: any) => {
      this.numPages = data.numPages
    })
  }
}
